import {CustomActivityIndicator} from 'design-system/src/Components/CustomActivityIndicator';
import React from 'react';
import {View} from 'react-native';

const PageLoader = () => {
  return (
    <div>
      <View
        style={{
          flex: 1,
          justifyContent: 'center',
          alignItems: 'center',
          minHeight: '100vh',
        }}>
        <CustomActivityIndicator style={{maxWidth: 20}} />
      </View>
    </div>
  );
};

export default PageLoader;
